// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_firebase_firestore_dist_esm_index_esm_js"], () => (__webpack_require__("./src/app/index.mjs")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
